import { ReactNode, useEffect, useRef, useState } from 'react';
import style from './style.module.css';

interface MenuProps {
    children?: ReactNode;
    onClose?: () => void;
    isOpened?: boolean;
    backdropDismiss?: boolean;
}

const Menu = ({ children, onClose = () => { }, isOpened = false, backdropDismiss = true }: MenuProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const mouseDownTarget = useRef<EventTarget | null>(null);
    const [shouldRenderChildren, setShouldRenderChildren] = useState(isOpened);

    useEffect(() => {
        if (isOpened) {
            setShouldRenderChildren(true);
        } else {
            const timer = setTimeout(() => setShouldRenderChildren(false), 300);
            return () => clearTimeout(timer);
        }
    }, [isOpened]);

    useEffect(() => {
        document.body.style.overflow = isOpened ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpened]);

    const handleClose = () => {
        if (!backdropDismiss) return;
        onClose();
    }

    return (
        <div
            className={`${style.bgd} ${style.side} ${isOpened ? style.opened : ''}`}
            onMouseUp={(event) => {
                // Preventing menu close when interacting with dropdowns inside the menu.
                const target = event.target as Element | null;
                const clickIsInPortal = target && target instanceof Element && Boolean(target.closest('[data-dropdown-portal]'));

                if (
                    mouseDownTarget.current &&
                    ref.current &&
                    !ref.current.contains(mouseDownTarget.current as Node) &&
                    !ref.current.contains(event.target as Node) &&
                    !clickIsInPortal
                ) {
                    handleClose();
                }
            }}
            onMouseDown={(event) => {
                mouseDownTarget.current = event.target;
            }}
            onTouchStart={(event) => {
                mouseDownTarget.current = event.target;
            }}
            onTouchEnd={(event) => {
                // Mirror onMouseUp logic for touch devices
                const target = event.target as Element | null;
                const clickIsInPortal = target && target instanceof Element && Boolean(target.closest('[data-dropdown-portal]'));

                if (
                    mouseDownTarget.current &&
                    ref.current &&
                    !ref.current.contains(mouseDownTarget.current as Node) &&
                    !ref.current.contains(event.target as Node) &&
                    !clickIsInPortal
                ) {
                    handleClose();
                }
            }}
        >
            <div className={style.window} ref={ref}>
                {/* <div className={style.close} onClick={handleClose}>
                    <Cross />
                </div> */}
                <div className={style.content}>{shouldRenderChildren && children}</div>
            </div>
        </div>
    );
};

export default Menu;